module.exports = __webpack_public_path__ + "public/images/engineering.d2c0076510e2d9c1df7bc10ec8ee0183.png";